<template>
  <card>
    <svg-plot :config="config">
      <svg-h-bars :data="bars" />
    </svg-plot>
  </card>
</template>

<script>
import Card from '@/components/charts/dev/Card.vue'
import SvgPlot from '@/components/charts/svg/plot/Plot.vue'
import SvgHBars from '@/components/charts/svg/plot/HBars.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    Card,
    SvgPlot,
    SvgHBars
  },
  data () {
    return {
      config: {
        grid: {
          horizontal: true
        },
        axis: {
          y: [
            { value: 0, label: 'Бумажные технологии' },
            { value: 1, label: 'Металлоцентр Лидер-М' },
            { value: 2, label: 'СГС-БИОТЭК' },
            { value: 3, label: 'Соноко-Алкор' },
            { value: 4, label: 'Энергосервис' },
            { value: 5, label: 'СУЗМК ЭНЕРГО' },
            { value: 6, label: 'Альтаир (Омск)' },
            { value: 7, label: 'ГАКЗ' },
            { value: 8, label: 'УралФПО' },
            { value: 9, label: 'Цемек Минералс' }
          ],
          division: {
            x: 4
          },
          discreteHeight: 25
        },
        chartArea: {
          x: 40, width: 50
        },
        style: {
          label: {
            y: { fill: 'black', reponsive: false }
          }
        }
      },
      bars: [
        {
          x: { bars: [{ value: 20, color: colors[0] }, { value: 120, color: colors[1] }], label: { text: 20, color: colors[0] } },
          y: 0
        },
        {
          x: { bars: [{ value: 30, color: colors[0] }, { value: 130, color: colors[1] }], label: { text: 20, color: colors[0] } },
          y: 1
        },
        {
          x: { bars: [{ value: 40, color: colors[0] }, { value: 140, color: colors[1] }], label: { text: 40, color: colors[0] } },
          y: 2
        },
        {
          x: { bars: [{ value: 10, color: colors[0] }, { value: 100, color: colors[1] }], label: { text: 10, color: colors[0] } },
          y: 3
        },
        {
          x: { bars: [{ value: 30, color: colors[0] }, { value: 80, color: colors[1] }], label: { text: 20, color: colors[0] } },
          y: 4
        },
        {
          x: { bars: [{ value: 50, color: colors[0] }, { value: 90, color: colors[1] }], label: { text: 50, color: colors[0] } },
          y: 5
        },
        {
          x: { bars: [{ value: 20, color: colors[0] }, { value: 80, color: colors[1] }], label: { text: 20, color: colors[0] } },
          y: 6
        },
        {
          x: { bars: [{ value: 10, color: colors[0] }, { value: 90, color: colors[1] }], label: { text: 10, color: colors[0] } },
          y: 7
        },
        {
          x: { bars: [{ value: 20, color: colors[0] }, { value: 75, color: colors[1] }], label: { text: 20, color: colors[0] } },
          y: 8
        },
        {
          x: { bars: [{ value: 20, color: colors[0] }, { value: 76, color: colors[1] }], label: { text: 20, color: colors[0] } },
          y: 9
        }
      ]
    }
  }
}
</script>
